import { useNavigate } from 'react-router-dom';
import { Box, Flex, Text, chakra } from '@chakra-ui/react';
import { Logo } from '@/components/ui/Logo/Logo';

export const SignupChooserPage = () => {
  const navigate = useNavigate();

  return (
    <Flex
      minH="100vh"
      bgGradient="to-b"
      gradientFrom="gray.50"
      gradientTo="white"
      justify="center"
      align="center"
      px="4"
      py="12"
    >
      <Box
        w="full"
        maxW="440px"
        borderRadius="xl"
        border="1px solid"
        borderColor="volyx.borderLight"
        bg="white"
        boxShadow="lg"
        overflow="hidden"
      >
        <Box p="8">
          <Flex justify="center" mb="2">
            <Logo mb="0" />
          </Flex>

          <Text as="h1" mt="0" fontSize="2xl" fontWeight="semibold" lineHeight="snug" color="volyx.text" textAlign="center">
            Choose account type
          </Text>
          <Text mt="2" fontSize="sm" color="volyx.textSecondary" textAlign="center">
            You can sign up as a volunteer or an organization.
          </Text>

          <Flex direction="column" gap="3" mt="6">
            <chakra.button
              type="button"
              w="full"
              px="6"
              py="3"
              borderRadius="xl"
              fontWeight="semibold"
              transition="all 0.3s"
              cursor="pointer"
              border="none"
              outline="none"
              bg="volyx.primary"
              color="white"
              boxShadow="md"
              _hover={{ boxShadow: 'lg', transform: 'translateY(-2px) scale(1.02)' }}
              _focus={{ outline: 'none' }}
              onClick={() => navigate('/signup/volunteer')}
            >
              Volunteer
            </chakra.button>

            <chakra.button
              type="button"
              w="full"
              h="12"
              px="6"
              borderRadius="xl"
              fontWeight="semibold"
              transition="all 0.2s"
              cursor="pointer"
              border="1px solid"
              borderColor="volyx.borderLight"
              bg="white"
              color="volyx.text"
              _hover={{ bg: 'gray.50' }}
              _focus={{ outline: 'none' }}
              onClick={() => navigate('/signup/organization')}
            >
              Organization
            </chakra.button>
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

